export default __webpack_public_path__ + "static/media/evi-t-fQ9X2rPEwq8-unsplash.2f0c1c52.jpg";